import { Link } from "react-router-dom";

export const Logo = ({ className = "", testId = "site-logo", onClick }) => (
  <Link
    to="/"
    onClick={onClick}
    data-testid={testId}
    aria-label="SwastSaathi — home"
    className={`group inline-flex items-center gap-2.5 ${className}`}
  >
    <img src="/logo-mark.png" alt="" width="40" height="37" className="h-9 w-auto transition-transform duration-500 group-hover:rotate-[-6deg]" />
    <img src="/logo-wordmark.png" alt="SwastSaathi" width="150" height="22" className="h-[22px] w-auto" />
  </Link>
);
